import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  return (
    <>
      <Container fluid className="App-bg-color-dark">
        <Row style={{ paddingLeft: "16px", paddingTop: "16px" }}>
          <Col>
            <h3 className="tinos-regular">urban group</h3>
          </Col>
        </Row>
        <hr></hr>
        <Row
          className="quattrocento-sans-regular"
          style={{ paddingLeft: "32px", paddingTop: "16px" }}
        >
          <Col>
            <h3>Info</h3>
            <ul
              style={{
                listStyle: "none",
                paddingLeft: "0",
              }}
            >
              <li>Elmwood House</li>
              <li>35 Ranelagh</li>
              <li>Ranelagh</li>
              <li>Dublin 6</li>
              <li>D06 Y2P4</li>
            </ul>
          </Col>
          <Col>
            <h3>Contact</h3>
            <ul
              style={{
                listStyle: "none",
                paddingLeft: "0",
              }}
            >
              <li>
                <b>Phone: </b>
                <a
                  id="phone-link"
                  href="tel:+35315240777"
                  style={{ color: "whitesmoke", textDecoration: "none" }}
                >
                  +353 (1) 524 0777
                </a>
              </li>
              <li>
                <b>Email: </b>
                <a
                  id="email-link"
                  href="mailto:HelloUrbanGroup@gmail.com"
                  style={{ color: "whitesmoke", textDecoration: "none" }}
                >
                  HelloUrbanGroup@gmail.com
                </a>
              </li>
              <li>
                <b>Web: </b>
                <a
                  id="web-link"
                  href="https://www.urbangroup.ie"
                  target="_blank"
                  style={{ color: "whitesmoke", textDecoration: "none" }}
                  rel="noreferrer"
                >
                  www.urbangroup.ie
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="quattrocento-sans-regular">
          <Col style={{ textAlign: "center" }}>
            <p>Copyright &copy; Urban Group</p>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Footer;
